// Sender-side rate limit for board pings.
//
// Single hard minimum gap between any two consumed pings. Enforced on
// the sender side only; the receiver renders whatever arrives. A blocked
// ping is meant to be silent. No chime, no ring, no network. So the
// limiter only returns a boolean and leaves "do nothing" to the caller.
//
// `now` is injected so tests can advance the clock deterministically.

export const PING_MIN_INTERVAL_MS = 400;

export function createPingRateLimiter({ now = Date.now, intervalMs = PING_MIN_INTERVAL_MS } = {}) {
  let lastConsumedAt = -Infinity;

  function tryConsume() {
    const t = now();
    if (t - lastConsumedAt < intervalMs) return false;
    lastConsumedAt = t;
    return true;
  }

  return { tryConsume };
}
